import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MercaderiaFueraRutaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerxEmpresaXSucursalxChoferxCamion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $listaChoferes: [Decimal], $listaCamiones: [String], $fechaRegistro: String, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          mercaderia_fuera_ruta {
            obtenerxEmpresaXSucursalxChoferxCamion(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, listaChoferes: $listaChoferes, listaCamiones: $listaCamiones, fechaRegistro: $fechaRegistro, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  camion_patente
                  chofer_rut
                  cliente_proveedor_rut
                  codigo
                  direccion_codigo
                  fecha
                  fecha_registro
                  monto_total
                  nombreChofer
                  nombreCliente
                  rut_empresa
                  sucursal_codigo
                  tipo_ingreso_codigo
                }
              }
            }
          }
        }        
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mercaderia_fuera_ruta.obtenerxEmpresaXSucursalxChoferxCamion;
            callback({ mensajes, respuesta });
        });
    }
    obtenerRetornoMercaderiaFueraRuta(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $codigo: Decimal) {
          mercaderia_fuera_ruta {
            obtenerRetornoMercaderiaFueraRuta(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, codigo: $codigo) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                cabecera {
                  camion_patente
                  chofer_rut
                  cliente_proveedor_rut
                  codigo
                  direccion_codigo
                  fecha
                  fecha_registro
                  monto_total
                  rut_empresa
                  sucursal_codigo
                  tipo_ingreso_codigo
                  glosa
                }
                detalle {
                  cantidad
                  empresa_rut
                  formato_codigo
                  glosa
                  linea
                  mercaderia_fuera_ruta_codigo
                  monto_total
                  precio_venta
                  producto_codigo
                  descripProducto
                  skuProducto
                  descripFormato
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mercaderia_fuera_ruta.obtenerRetornoMercaderiaFueraRuta;
            callback({ mensajes, respuesta });
        });
    }
    grabarRetornoMercaderiaFueraRuta(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: mercaderia_fuera_rutaDTOInputType, $rutUsuario: Decimal) {
          mercaderia_fuera_ruta {
            grabarRetornoMercaderiaFueraRuta(entidad: $entidad, rutUsuario: $rutUsuario) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                folioGuia
                folioNC
                tipoDTEGuia
                tipoDTENC
                cabecera {
                  camion_patente
                  codigo
                  cliente_proveedor_rut
                  direccion_codigo
                  fecha
                  fecha_registro
                  monto_total
                  rut_empresa
                  sucursal_codigo
                  tipo_ingreso_codigo
                  glosa
                }
                detalle {
                  cantidad
                  empresa_rut
                  formato_codigo
                  glosa
                  linea
                  mercaderia_fuera_ruta_codigo
                  precio_venta
                  monto_total
                  producto_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.mercaderia_fuera_ruta.grabarRetornoMercaderiaFueraRuta;
            callback({ mensajes, respuesta });
        });
    }
}
MercaderiaFueraRutaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MercaderiaFueraRutaService_Factory() { return new MercaderiaFueraRutaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MercaderiaFueraRutaService, providedIn: "root" });
